<template>
  <page-content-main
    :no-padding="noPadding"
    :no-bottom-padding="noBottomPadding"
    :size="size"
  >
    <page-content-main-block>
      <div>
        <slot name="before" />
      </div>

      <page-content-top
        v-if="!noTopContent"
        :title="title"
        :page-content-top-block-style="pageContentTopBlockStyle"
      >
        <template v-slot:title>
          <slot name="title" />
        </template>

        <template v-slot:page-content-top-right>
          <slot name="page-content-top-right" />
        </template>
      </page-content-top>

      <div
        class="page-content-default-wrapper__content"
        :class="{ 'page-content-default-wrapper__content--full-height': fullScrollHeight }"
      >
        <slot />
      </div>
    </page-content-main-block>
  </page-content-main>
</template>

<script setup lang="ts">
import PageContentMain, { type PageContentMainSize } from '@/components/layout/pageContent/PageContentMain.vue'
import PageContentMainBlock from '@/components/layout/pageContent/PageContentMainBlock.vue'
import PageContentTop from '@/components/layout/pageContent/PageContentTop.vue'

defineProps<{
  title?: string
  size?: PageContentMainSize
  noPadding?: boolean
  noBottomPadding?: boolean
  noTopContent?: boolean
  fullScrollHeight?: boolean
  pageContentTopBlockStyle?: Pick<CSSStyleDeclaration, 'alignItems'>
}>()
</script>

<style lang="scss" scoped>
.page-content-default-wrapper {
  &__content {
    flex: 1;
    width: 100%;
    max-width: 100%;
    position: relative;

    // fix extra scroll for pages with tabs and resolver
    :deep(.resolver) {
      height: auto;
    }

    &--full-height {
      :deep(.resolver) {
        height: 100% !important;
      }
    }
  }
}
</style>
